;(function($, undefined){
    var rnn, log, maps;

    function setLocationFields($searchForm, position){

        if($searchForm.closest('.whats-on.search').length){
            if(position){
                $searchForm.find(".origin").val(position.coords.latitude + ',' + position.coords.longitude);
            }else{
                $searchForm.find(".origin").val(null);
            }
        }

        $searchForm.find(".latitude").val(position && position.coords.latitude);
        $searchForm.find(".longitude").val(position && position.coords.longitude);
        $searchForm.find(".locationSelect options:first").attr('selected','seleted');
    }

    function clearLocationFields($searchForm){

        if($searchForm.closest('.whats-on.search').length){
            $searchForm.find(".origin").val(null);
        }

        $searchForm.find(".latitude").val(null);
        $searchForm.find(".longitude").val(null);
        $searchForm.find('.useMyLocation').removeClass('on');
    }


    function getLocation(success, error) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success,error);
        } else {
            alert("Your device currently does not support this feature");
        }
    }

    function noLocationError($form){
        rnn.modules.alert.show($form, "Unfortunately, your location could not be determined");
        $form.find('.useMyLocation').removeClass('on');
    }

    function toggleLocationUse($searchForm, force){
        var useMyLocationButton = $searchForm.find('.useMyLocation');

        function useMyLocation(position){
            setLocationFields($searchForm, position);
            $searchForm.submit();
        }

        if(force === false || useMyLocationButton.is('.on') && force !== true){
            useMyLocationButton.removeClass('on');

            setLocationFields($searchForm, null);
        }else{
            useMyLocationButton.addClass('on');

            getLocation(useMyLocation, function(){noLocationError($searchForm);});
        }
    }

    function initMaps() {
        var locationSearchForm = $('.locationSearchForm');

        locationSearchForm.on('click', '.useMyLocation', function(){
            toggleLocationUse($(this).closest('form'));
        }).on('change', '.locationSelect', function(){
            clearLocationFields($(this).closest('form'));
            $(this).closest('form').submit();
        }).on('click', '.locationSelect option', function(){
            clearLocationFields($(this).closest('form'));
            $(this).closest('form').submit();
        });
    }

    // Initialise Buisnesses
    function initLocationControls() {
        initMaps();
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    maps = rnn.modules.maps;

    rnn.modules.register('location', {
        init: initLocationControls,
        getLocation: getLocation
    });

})(jQuery);
